/**
 * RPS-SURVEYS-CONFIG
 * Carte des reglages prevention : les enquetes RPS du compte et la decision prise sur chacune.
 */
import RpsMappingModal from "./modal/RpsMappingModal"
import Card from "@/components/card"
import { useAppSelector } from "@/core/root-reducer"
import RpsSurveyList from "@/entities/physical-risk/ui/RpsSurveyList"
import { faHeart } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"

export default function RpsSurveysConfig() {
  //Le module RPS porte le tableau de bord qui exploite l'enquete : sans lui, rien a importer
  const isRpsModuleActive = useAppSelector((state) => state._session.modules.survey.rps)

  const [mappingOpen, setMappingOpen] = useState<"manual" | "assistant" | null>(null)

  if (!isRpsModuleActive) return null

  return (
    <Card>
      {mappingOpen && <RpsMappingModal suggest={mappingOpen === "assistant"} onClose={() => setMappingOpen(null)} />}
      <div className="mb-4 flex items-center gap-3">
        <FontAwesomeIcon icon={faHeart} className="grey-t text-lg" />
        <span className="text-lg">Enquêtes RPS</span>
      </div>

      <RpsSurveyList
        className="card-content-list"
        onConfigure={(suggest) => setMappingOpen(suggest ? "assistant" : "manual")}
      />
    </Card>
  )
}
